"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.segmentMatcherContext = void 0;
var thenable_1 = require("../../utils/promise/thenable");
function segmentMatcherContext(segmentName, storage) {
    return function segmentMatcher(key) {
        var isInSegment = storage.segments.isInSegment(segmentName, key);
        if ((0, thenable_1.thenable)(isInSegment)) {
            isInSegment.then(function (result) {
                return result;
            });
        }
        return isInSegment;
    };
}
exports.segmentMatcherContext = segmentMatcherContext;
